"use strict";
exports.__esModule = true;
var date_fns_1 = require("date-fns");
var react_1 = require("react");
var time_1 = require("./time");
/**
 * @name useCountdown
 * @description React hook countdown timer.
 */
var useCountdown = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.minutes, minutes = _c === void 0 ? 0 : _c, _d = _b.seconds, seconds = _d === void 0 ? 0 : _d, _e = _b.format, format = _e === void 0 ? "mm:ss" : _e, onCompleted = _b.onCompleted;
    var id = (0, react_1.useRef)(0);
    // time
    var _f = (0, react_1.useState)((0, time_1.calculateInitialTime)({ minutes: minutes, seconds: seconds })), remainingTime = _f[0], setRemainingTime = _f[1];
    // status
    var _g = (0, react_1.useState)(false), isActive = _g[0], setIsActive = _g[1];
    var _h = (0, react_1.useState)(true), isInactive = _h[0], setIsInactive = _h[1];
    var _j = (0, react_1.useState)(false), isRunning = _j[0], setIsRunning = _j[1];
    var _k = (0, react_1.useState)(false), isPaused = _k[0], setIsPaused = _k[1];
    (0, react_1.useEffect)(function () {
        id.current = window.setInterval(calculateRemainingTime, 1000);
        setIsActive(true);
        setIsInactive(false);
        setIsRunning(true);
        setIsPaused(false);
        return function () { return window.clearInterval(id.current); };
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var calculateRemainingTime = function () {
        setRemainingTime(function (time) {
            if (time - 1000 <= 0) {
                window.clearInterval(id.current);
                onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted();
                setIsActive(false);
                setIsInactive(true);
                setIsRunning(false);
                setIsPaused(false);
                return 0;
            }
            return time - 1000;
        });
    };
    var pause = function () {
        if (isPaused || isInactive) {
            return;
        }
        window.clearInterval(id.current);
        setIsActive(true);
        setIsInactive(false);
        setIsRunning(false);
        setIsPaused(true);
    };
    var resume = function () {
        if (isRunning) {
            return;
        }
        id.current = window.setInterval(calculateRemainingTime, 1000);
        setIsActive(true);
        setIsInactive(false);
        setIsRunning(true);
        setIsPaused(false);
    };
    var reset = function (time) {
        if (time === void 0) { time = { minutes: minutes, seconds: seconds }; }
        window.clearInterval(id.current);
        id.current = window.setInterval(calculateRemainingTime, 1000);
        setIsActive(true);
        setIsInactive(false);
        setIsRunning(true);
        setIsPaused(false);
        setRemainingTime((0, time_1.calculateInitialTime)(time));
    };
    var countdown = {
        minutes: (0, time_1.calculateRemainingMinutes)(remainingTime),
        seconds: (0, time_1.calculateRemainingSeconds)(remainingTime),
        formatted: (0, date_fns_1.format)(remainingTime, format),
        isActive: isActive,
        isInactive: isInactive,
        isRunning: isRunning,
        isPaused: isPaused,
        pause: pause,
        resume: resume,
        reset: reset
    };
    return countdown;
};
exports["default"] = useCountdown;
//# sourceMappingURL=countdown.js.map